import Axios from 'axios';
import {apiProxy, Payload} from "./proxy.services";

const RESOURCE_NAME_REMOVE_GHOST = '/Ryvuss/RemoveGhostByDealer';
const GET_HISTORICAL_ADVERTS = '/Mantencion/GetHistorico';
const API_OPERACIONES = `${process.env.VUE_APP_API_ENDPOINT}`;
const REPUBLISH = '/avisos/republish';

export default {
    historical: {
        getSearch(data) {
            return Axios.post(GET_HISTORICAL_ADVERTS, data);
        }
    },
    removeGhost: {
        delete(data) {
            return Axios.post(RESOURCE_NAME_REMOVE_GHOST, data);
        }
    },
    async republishAdverts(codeAdverts) {
        const options = new Payload(`${API_OPERACIONES}${REPUBLISH}`, 'POST', codeAdverts);

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if (error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);

            throw new Error(error);
        }
    },

};
